// AgentCreation.js (similar to UnitCreations.js)
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputForm } from "../../components/Forms";
const AgentCreations = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div>
      <Container>
        <Row>
          <Col lg="12" className="py-3">
            <TextInputForm
              textlabel="Agent Name"
              name="agent_name"
              value={formData.agent_name || ""}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default AgentCreations;
